export const PERIODIC_REPORT_LANGUAGES = [
  { locale: 'de_DE', name: 'turns-periodic.language.de_DE' },
  { locale: 'el_GR', name: 'turns-periodic.language.el_GR' },
  { locale: 'en_GB', name: 'turns-periodic.language.en_GB' },
  { locale: 'es_ES', name: 'turns-periodic.language.es_ES' },
  { locale: 'fr_FR', name: 'turns-periodic.language.fr_FR' },
  { locale: 'it_IT', name: 'turns-periodic.language.it_IT' },
  { locale: 'pt_PT', name: 'turns-periodic.language.pt_PT' },
  { locale: 'tr_TR', name: 'turns-periodic.language.tr_TR' }
];
